package com.tovtalk.data.mapper

import com.tovtalk.data.remote.dto.UserDto
import com.tovtalk.data.remote.dto.UserLinkDto
import com.tovtalk.domain.entity.*
import kotlin.time.Instant

/**
 * User Mapper - DTO to Entity
 */
object UserMapper {
    
    fun mapToEntity(dto: UserDto): User {
        return User(
            id = dto.id,
            firebaseUid = dto.firebaseUid ?: "",
            identity = dto.identity ?: dto.username,
            fullname = dto.fullname,
            username = dto.username,
            email = dto.userEmail,
            profilePhoto = dto.profilePhoto,
            bio = dto.bio,
            
            followerCount = dto.followerCount,
            followingCount = dto.followingCount,
            totalPostLikesCount = dto.totalPostLikesCount,
            
            coinWallet = dto.coinWallet,
            coinCollectedLifetime = dto.coinCollectedLifetime,
            coinGiftedLifetime = dto.coinGiftedLifetime,
            coinPurchasedLifetime = dto.coinPurchasedLifetime,
            
            isVerified = dto.isVerify,
            isFreeze = dto.isFreez,
            isReadOnly = dto.isReadOnly == true,
            showFeedAds = dto.showFeedAds,
            showProfileAds = dto.showProfileAds,
            isModerator = dto.isModerator,
            
            appLanguage = dto.appLanguage,
            whoCanViewPost = WhoCanViewPost.fromInt(dto.whoCanViewPost),
            showMyFollowing = dto.showMyFollowing,
            receiveMessage = dto.receiveMessage,
            
            notifyPostLike = dto.notifyPostLike,
            notifyPostComment = dto.notifyPostComment,
            notifyFollow = dto.notifyFollow,
            notifyMention = dto.notifyMention,
            notifyGiftReceived = dto.notifyGiftReceived,
            notifyChat = dto.notifyChat,
            notifyMessageRequests = dto.notifyMessageRequests,

            country = dto.country,
            countryCode = dto.countryCode,
            region = dto.region,
            city = dto.city,
            lat = dto.lat,
            lon = dto.lon,
            
            kashrutLevel = dto.kashrutLevel,
            artistType = dto.artistType,
            consumptionCategoryIds = dto.consumptionCategoryIds,
            uploadCategoryId = dto.uploadCategoryId,
            instagramId = dto.instagramId,
            whatsappStatusId = dto.whatsappStatusId,
            youtubeChannelId = dto.youtubeChannelId,
            autoPullInstagram = dto.autoPullInstagram,
            autoPullWhatsappStatus = dto.autoPullWhatsappStatus,
            autoPullYoutube = dto.autoPullYoutube,
            autoUpdateProfileInstagram = dto.autoUpdateProfileInstagram,
            autoUpdateProfileWhatsappStatus = dto.autoUpdateProfileWhatsappStatus,
            autoUpdateProfileYoutube = dto.autoUpdateProfileYoutube,
            isFollowing = dto.isFollowing,
            hasActiveStory = dto.hasActiveStory,
            followStatus = FollowStatus.fromInt(dto.followStatus),
            isBlocked = dto.isBlocked,
            
            links = dto.links?.map { mapLinkToEntity(it) } ?: emptyList(),
            
            createdAt = dto.createdAt?.let { parseInstant(it) } ?: Instant.fromEpochMilliseconds(0),
            updatedAt = dto.updatedAt?.let { parseInstant(it) } ?: Instant.fromEpochMilliseconds(0),
            appLastUsedAt = dto.appLastUsedAt?.let { parseInstant(it) },
            usernameChangedAt = dto.usernameChangedAt?.let { parseInstant(it) }
        )
    }
    
    private fun mapLinkToEntity(dto: UserLinkDto): UserLink {
        return UserLink(
            id = dto.id,
            title = dto.title,
            url = dto.url,
            linkType = when (dto.linkType) {
                1 -> LinkType.INSTAGRAM
                2 -> LinkType.YOUTUBE
                3 -> LinkType.SHOP
                4 -> LinkType.WEBSITE
                else -> LinkType.OTHER
            }
        )
    }

    private fun Boolean.toInt() = if (this) 1 else 0
}
